import React from "react";
import NeighbourhoodIcon from '@mui/icons-material/Cottage';
import {SvgIconProps} from "@mui/material/SvgIcon/SvgIcon";
import {INeighbourhood} from "../../api/Model";


export default function NeighbourhoodColorIcon({neighbourhood, size, sx, ...props}: ({
    neighbourhood: INeighbourhood,
    size?: string | number,
}) & SvgIconProps) {
    return (
        <NeighbourhoodIcon
            sx={{
                color: neighbourhood.displayColor,
                width: size ?? '1.5rem',
                height: size ?? '1.5rem',
                borderRadius: '0.25rem',
                ...sx,
            }}
            {...props}
        />
    );
}